export const NAVIGATION_MODE = {
  LINEAR: 'linear',
  NON_LINEAR: 'non-linear',
  FORWARD_ONLY: 'forward-only',
} as const;
